{
  "screen": {
    "overline": "GLOBAL PRACTICUM",
    "title": "Schedule",
    "subtitle": "Your personal event calendar. Live sessions, retreats, workshops, and ceremonies — curated in one place, aligned with your rhythm and interests.",
    "liveStreams": "Live Sessions",
    "programEvent": {
      "note": "Part of a program you bought",
      "cta": "In your program"
    },
    "eventsTab": "Events",
    "loading": "Syncing live status...",
    "noSessions": "No Upcoming Sessions",
    "noSessionsHint": "Check back soon for new live sessions from our global masters.",
    "browseEvents": "Browse Events",
    "streamingNow": "LIVE",
    "upcomingSessions": "Upcoming Sessions",
    "allSessions": "All Sessions",
    "subscribed": "Subscribed",
    "subscribedCount": "Subscribed ({{count}})",
    "allTraditions": "All Traditions",
    "tradition": "TRADITION",
    "tags": "TAGS",
    "segmentAll": "All",
    "segmentAgape": "Agapē",
    "segmentMasters": "Masters",
    "eventCount": "{{count}} Event",
    "eventCount_plural": "{{count}} Events",
    "live": "LIVE",
    "subscribedBtn": "SUBSCRIBED",
    "notifyMe": "NOTIFY ME",
    "loadingEvents": "Loading events...",
    "noEventsFound": "No Events Found",
    "noEventsForTradition": "No {{tradition}} events scheduled yet.",
    "noEventsForTags": "No events match the selected tags.",
    "noMasterEvents": "No master events scheduled yet.",
    "noAgapeEvents": "No Agapē events scheduled yet.",
    "noEventsDefault": "No events scheduled yet.",
    "clearFilters": "Clear Filters",
    "tryAgain": "Try Again",
    "calendarDownloaded": "Calendar file downloaded",
    "calendarFailed": "Failed to download calendar file",
    "reminderSet": "Reminder set",
    "reminderFailed": "Failed to set reminder"
  },
  "filters": {
    "master": "Master",
    "specialty": "Specialty",
    "timeOfDay": "Time of Day",
    "morning": "Morning",
    "afternoon": "Afternoon",
    "evening": "Evening",
    "night": "Night",
    "allMasters": "All Masters",
    "allSpecialties": "All",
    "clearAll": "Clear filters",
    "noResults": "No sessions match your filters",
    "clearAndRetry": "Clear filters",
    "searchMasters": "Search masters..."
  },
  "detail": {
    "loading": "Connecting to the live session...",
    "unavailable": "Live Session Unavailable",
    "unavailableHint": "This live session could not be found or is no longer available.",
    "programLiveGone": "This live session is no longer on the schedule",
    "programLiveGoneHint": "The master cancelled or removed it. It was part of the program “{{program}}” — the current schedule is there.",
    "programLiveGoneHintNoTitle": "The master cancelled or removed it. The current schedule is on the program page.",
    "openProgram": "Go to the program",
    "backToLives": "Back to events",
    "backToSchedule": "BACK TO SCHEDULE",
    "ended": "Session Has Ended",
    "endedHint": "This live session with {{name}} has concluded. A recording may be available soon.",
    "viewMaster": "VIEW MASTER",
    "invite": "Invite",
    "edit": "Edit",
    "signIn": "Sign In",
    "translate": "Translate",
    "streamingTranslation": "Streaming translation",
    "chooseLanguage": "Choose Language",
    "searchLanguages": "Search languages...",
    "noLanguagesMatch": "No languages match your search",
    "noLanguages": "No additional languages available",
    "signUpReserve": "Create an account to reserve your spot",
    "cancelReservation": "Cancel reservation?",
    "cancelReservationHint": "You will no longer receive reminders for this session.",
    "keep": "Keep",
    "cancelReservationBtn": "Cancel reservation",
    "signUpReminders": "Sign up to enable reminders for this session",
    "signUpFavorites": "Sign up to save your favorite sessions",
    "inFavorites": "IN FAVORITES",
    "addToFavorites": "ADD TO FAVORITES",
    "remindMe": "Remind me",
    "calendar": "Calendar",
    "inboxLink": "A direct link will be sent to your inbox 10 minutes before the session starts.",
    "follow": "Follow",
    "following": "Following",
    "aboutSession": "About this session",
    "presenter": "Host"
  },
  "cancelDialog": {
    "title": "Cancel the event?",
    "message": "“{{title}}” will be cancelled. {{notice}} This can’t be undone.",
    "confirm": "Cancel event",
    "keep": "Keep it",
    "done": "Event deleted",
    "noticeCircle": "Subscribers will be notified in the Circle chat.",
    "noticeProgram": "Everyone who bought the program will be notified.",
    "noticeSignedUp": "Everyone who signed up will be notified."
  },
  "status": {
    "streamingNow": "LIVE",
    "startsInDays": "STARTS IN {{days}}D {{hours}}H",
    "startsInHours": "STARTS IN {{hours}}H {{minutes}}M",
    "startsInMinutes": "STARTS IN {{minutes}}M"
  },
  "stream": {
    "connecting": "Connecting to the live session...",
    "waitingForHost": "Waiting for the host to start the live session...",
    "unavailable": "Live session unavailable",
    "endConfirm": "Are you sure you want to stop the live session?",
    "endBroadcast": "End Live Session",
    "endStream": "End Stream",
    "endLiveEvent": "End Live Event",
    "endLiveConfirm": "This will stop the live session AND end the event for all viewers. Are you sure?",
    "endReadyConfirm": "This will end the live event so it is no longer visible to viewers. Are you sure?"
  },
  "broadcast": {
    "webOnly": "Live sessions are only available on the web",
    "inProgress": "Live Session in Progress",
    "leaveConfirm": "Your live session is running. Leaving this page will end it. Are you sure?",
    "stay": "Stay",
    "endAndLeave": "End & Leave",
    "studio": "STUDIO",
    "dashboard": "Dashboard",
    "preparing": "Preparing studio...",
    "readyTitle": "Ready to Go Live",
    "readyHint": "Camera will activate when the live session starts",
    "connectingStream": "Connecting to the live session...",
    "complete": "Live Session Complete",
    "savedHint": "Session saved successfully",
    "connectionError": "Connection error",
    "sessionDetails": "SESSION DETAILS",
    "titleLabel": "Title",
    "scheduledLabel": "Scheduled",
    "durationLabel": "Duration",
    "goLive": "GO LIVE",
    "backToDashboard": "BACK TO DASHBOARD",
    "cancelEvent": "Cancel Event",
    "nowStreaming": "LIVE",
    "liveSessionDefault": "Live Session",
    "rec": "REC",
    "endStreamBtn": "END LIVE SESSION",
    "muted": "Muted",
    "audioOn": "Audio On",
    "cameraOff": "Camera Off",
    "videoOn": "Video On",
    "endFailed": "Failed to end live: {{error}}"
  },
  "share": {
    "subject": "Join the «{{title}}» live session on Agapella",
    "message": "Join the «{{title}}» live session on Agapella\n{{url}}"
  },
  "guest": {
    "webOnlyTitle": "The guest live session is available only in the browser",
    "webOnlyBody": "Open this link on a computer to join with your mic and camera.",
    "limitReachedTitle": "All seats are taken",
    "limitReachedBody": "All guest seats in this live session are taken. You can still join as a viewer — you'll see and hear all speakers and can chat with everyone.",
    "watchAsViewer": "Watch as a viewer",
    "openRecording": "Open recording",
    "expiredTitle": "This link is no longer active",
    "expiredBody": "This link was revoked or has expired. Ask the host to share a fresh one.",
    "notStartedTitle": "The live session hasn't started yet",
    "notStartedBody": "The host hasn't opened the live session yet. Refresh in a minute or wait for an invite.",
    "connectFailedTitle": "Couldn't connect",
    "media": {
      "retry": "Try again",
      "system_blockedTitle": "The system blocked your camera",
      "system_blockedBody": "The browser has access, the operating system does not. On Mac: System Settings → Privacy & Security → Camera and Microphone, enable your browser there and restart it. On Windows: Settings → Privacy → Camera and Microphone. Then come back and press «Try again».",
      "deniedTitle": "No access to camera and microphone",
      "deniedBody": "The browser didn't let us reach your camera. Click the lock icon next to the page address, allow camera and microphone, then press «Try again».",
      "not_foundTitle": "No camera or microphone found",
      "not_foundBody": "We can't see any camera or microphone. Connect a device and press «Try again». If the camera is built in, check that it isn't disabled in your system settings.",
      "in_useTitle": "Another app is using the camera",
      "in_useBody": "The camera seems to be in use by another tab or app — a video call, most likely. Close it and press «Try again»."
    },
    "masterDisconnectedTitle": "Host disconnected",
    "masterDisconnectedBody": "Connection with the host dropped. Waiting a few seconds — if they return, the live session continues.",
    "streamEndedTitle": "Live session ended",
    "streamEndedBody": "The host ended the live session. Thanks for being here. The recording and event info are on the live session page."
  },
  "wizard": {
    "audioCategory": {
      "All": "All",
      "Ambient": "Ambient",
      "BinauralBeats": "Binaural beats",
      "NatureSounds": "Nature sounds",
      "Mantra": "Mantras",
      "TibetanBowls": "Tibetan bowls",
      "WhiteNoise": "White noise",
      "Other": "Other"
    },
    "libraryCount": {
      "shown": "Showing {{shown}} of {{total}}",
      "partial": "Showing {{shown}} · library not fully loaded ({{loaded}} of {{total}})"
    },
    "libraryEmpty": {
      "noResults": "Nothing matched your search",
      "clearSearch": "Clear search"
    }
  },
  "native": {
    "rooms": {
      "calendar": {
        "openMonthA11y": "Open month",
        "prevMonthA11y": "Previous month",
        "nextMonthA11y": "Next month"
      },
      "title": "Live sessions",
      "intro": "Real-time online sessions together and recordings of past meetings with Agapella masters.",
      "create": "Create a live session",
      "tabs": {
        "upcoming": "Upcoming",
        "archive": "Archive"
      },
      "clearDateA11y": "Clear date: {{date}}",
      "empty": {
        "upcoming": "Nothing here yet",
        "upcomingHint": "Create your own practice and invite like-minded people.",
        "upcomingDay": "No live sessions planned for {{date}}",
        "upcomingDayHint": "Would you like to plan your own live session for this day?",
        "archive": "No recordings yet",
        "archiveHint": "Recordings of master sessions will appear here after the first practices.",
        "archiveDay": "No practice recordings for {{date}}",
        "archiveDayHint": "Pick another day in the calendar or go back to all recordings."
      },
      "card": {
        "seats_one": "{{taken}} of {{count}} spot",
        "seats_other": "{{taken}} of {{count}} spots",
        "recording": "Recording \u00b7 {{duration}}",
        "live": "Now",
        "own": "Yours",
        "untitled": "Untitled",
        "shareA11y": "Share: {{title}}"
      }
    },
    "subtitle": "Your path of practice and meetings",
    "calendarOverline": "LIFESTYLE",
    "eventsOn": "Events on {{date}}",
    "eventsOnDay": "Events on",
    "allEvents": "All events",
    "noEventsThisDay": "No events on this day",
    "noUpcoming": "No upcoming events",
    "whatsNext": "What's next",
    "nothingPlanned": "Nothing planned yet",
    "legend": {
      "online": "Online",
      "offline": "Offline",
      "recordings": "Recordings",
      "all": "All"
    },
    "filters": {
      "directions": "Directions",
      "directionsCount": "Directions ({{count}})",
      "liveSessions": "Live sessions",
      "offline": "Offline",
      "livePractices": "Live practices",
      "allDirections": "All directions"
    },
    "pickMonth": "Choose a month",
    "pickMonthA11y": "Choose a month",
    "done": "Done",
    "collections": {
      "title": "Collections",
      "seeAll": "See all ›"
    },
    "card": {
      "event": "Event",
      "minutes": "min",
      "master": "Master",
      "yours": "Your live session",
      "going": "I'm going",
      "join": "Join",
      "offline": "OFFLINE",
      "online": "ONLINE",
      "open": "Open"
    },
    "signInToJoin": "Sign in to register for the event",
    "gridWeekdays": [
      "M",
      "T",
      "W",
      "T",
      "F",
      "S",
      "S"
    ],
    "filtersTitle": "Filters",
    "reset": "Reset",
    "format": "Format",
    "durationTitle": "Duration",
    "showEvents": "Show events",
    "duration": {
      "any": "Any",
      "lt30": "Under 30 min",
      "30to60": "30–60 min",
      "gt60": "60+ min"
    },
    "detail": {
      "notFound": "Event not found",
      "participants": "Who's coming",
      "about": "About the event",
      "youWillGet": "What you'll get",
      "free": "Free",
      "liveNow": "Happening now",
      "ended": "Live session ended",
      "recordingOptional": "Recording optional",
      "watchRecording": "Watch the recording",
      "noRecording": "No recording",
      "openLive": "Open the live session",
      "openChat": "Live session chat",
      "previewLive": "Preview the live session",
      "registered": "You're signed up",
      "register": "Sign up"
    },
    "rsvp": {
      "going": "Going",
      "maybe": "Maybe",
      "no": "Not going",
      "total": "Participants",
      "soonTitle": "The participant list is coming",
      "soonText": "Going / Maybe / Not going marks will appear once we connect this section on the backend."
    },
    "summary": {
      "followFailed": "Couldn't follow",
      "tabRecording": "Recording",
      "tabChat": "Chat",
      "metaPeople_one": "{{count}} person",
      "metaPeople_other": "{{count}} people",
      "metaMessages_one": "{{count}} message",
      "metaMessages_other": "{{count}} messages",
      "shareA11y": "Share the live session",
      "endedBadge": "LIVE SESSION ENDED",
      "untitled": "Untitled",
      "host": "Host: {{name}}",
      "lasted": "Lasted {{duration}}",
      "peopleWere_one": "{{count}} person joined",
      "peopleWere_other": "{{count}} people joined",
      "messageCount": "Chat messages: {{count}}",
      "noChat": "Nobody wrote in this session.",
      "openAuthor": "Open {{name}}’s profile",
      "subscribing": "Subscribing…",
      "viewCount": "Recording views: {{count}}",
      "publish": "Publish to Media",
      "deleteAction": "Delete live session",
      "deleting": "Deleting…",
      "deleteTitle": "Delete the live session?",
      "deleteBody": "The live session «{{title}}» will be deleted entirely: its recording, chat, stats and place in your history go with it. If the recording was published to Media, it disappears from there too.",
      "deleteConfirm": "Delete live session",
      "deleteFailed": "Could not delete the session"
    },
    "sessionConflict": {
      "title": "A live session is in progress",
      "body": {
        "room": "To join another live session, leave “{{title}}” first.",
        "watch": "To watch this live session, leave “{{title}}” first.",
        "broadcast": "To start your own live session, leave “{{title}}” first."
      },
      "untitled": "Live session",
      "stay": "Stay",
      "leave": "Leave",
      "watchBlocked": "The video will open once you leave the current live session.",
      "watchBlockedAction": "Leave live session"
    },
    "guest": {
      "publishDenied": "The floor is yours, but the microphone has not opened yet. Leave and rejoin, or ask the host to grant the floor again"
    },
    "roomHeader": {
      "participants_one": "{{count}} participant",
      "participants_other": "{{count}} participants",
      "guestsA11y": "Watching without an account: {{count}}. Open the list",
      "host": "Host",
      "collapse": "Minimize the live session",
      "menu": "Live session menu",
      "recording": "This live session is being recorded. Details",
      "recordingHintTitle": "This live session is being recorded",
      "recordingHintBody": "Everything that can be seen and heard is being recorded.",
      "recordingHintOk": "Got it"
    },
    "chatToast": {
      "a11y": "New chat message from {{author}}: {{text}}. Open chat"
    },
    "media": {
      "muteA11y": "Mute the practice on this device",
      "unmuteA11y": "Unmute the practice"
    }
  }
}
